import { PropTypes } from "prop-types";
import intl from "react-intl-universal";

export const enumToOption = (enm) => {
  let options = [];
  for (var key in enm) {
    let title = "";
    if (enm[key].title) title = enm[key].title;
    else if (enm[key].titleKey) title = intl.get(enm[key].titleKey);
    options.push({ title, id: enm[key].id });
  }
  return options;
};
export const enumToLableValue = (enm) => {
  let options = [];
  for (var key in enm) {
    let title = "";
    if (enm[key].title) title = enm[key].title;
    else if (enm[key].titleKey) title = intl.get(enm[key].titleKey);

    options.push({ label: title, value: enm[key].id });
  }

  return options;
};

export const LOG_LEVEL = {
  DEBUG: { key: 1, title: "debug" },
  ERROR: { key: 2, title: "error" },
  FATALERROR: { key: 3, title: "fatalerror" },
};

export const DASHBOARD_STATUS = {
  ACTIVE: { id: 1, titleKey: "active" },
  INACTIVE: { id: 2, titleKey: "inactive" },
  COMINGSOON: { id: 3, titleKey: "comingsoon" },
};

export const ACTION = {
  INSERT: "insert",
  UPDATE: "update",
  DELETE: "delete",
  LOAD: "load",
};
export const USER_ROLE = {
  ADMIN: "admin",
};

export const PAGE_STATUS = {
  NAN: 0,
  LODING: 10,
  WAITING: 15,
  SAVING: 20,
  DONE: 200,
  ERROR: 500,
};


const Enum = {};
export default Enum;

Enum.contextTypes = {
  intl: PropTypes.object.isRequired,
};
